import {
  FilterActionsEnum,
  type QuickFilterAction,
  ValueSource,
} from '@unifyapps/defs/types/blocks';
import { isEmpty } from 'lodash';
import { convertUiFilterToFilter } from '../../../no-code/utils/filter/transformFilters';
import type { FiltersType } from '../../types';

export function getUpdatedQuickFilter(quickFilter?: QuickFilterAction) {
  const uiFilter = quickFilter?.dataFilter?.initialValue?.uiFilter;
  if (!uiFilter) return quickFilter;

  return {
    ...quickFilter,
    dataFilter: {
      ...quickFilter.dataFilter,
      initialValue: { filter: convertUiFilterToFilter(uiFilter) },
    },
  };
}

export function isQuickFilterSelected(quickFilter: QuickFilterAction, filterState?: FiltersType) {
  if (quickFilter.filterType === FilterActionsEnum.DateFilter) {
    return quickFilter.id === filterState?.dateQuickFilter?.id;
  }
  return quickFilter.id === filterState?.dataQuickFilter?.id;
}

export function checkQuickFilterValueConfigured(quickFilter: QuickFilterAction) {
  //   The "valueSource" concept was introduced to distinguish between custom and mapped values.
  //   Older configurations lack "valueSource", so they are treated as custom by default.

  //   Old structure for date quick filters:
  //     dateQuickFilter: { dateFilter: {...values} }
  //   New structure for date quick filters:
  //     dateQuickFilter: { valueSource: 'custom' | 'mapped', dateFilter: { initialValue: {...values}, mappedInitialValue: {...values} } }

  if (quickFilter.filterType === FilterActionsEnum.DateFilter) {
    if (quickFilter.valueSource === ValueSource.Mapped) {
      // Check if a mapped value is configured
      return Boolean(quickFilter.dateFilter?.mappedInitialValue);
    }

    if (quickFilter.valueSource === ValueSource.Custom) {
      // Check if an initial value is configured for custom sources
      // if configured we are in new construct with custom value source
      return !isEmpty(quickFilter.dateFilter?.initialValue);
    }

    // Default to treating as custom for older configurations
    return !isEmpty(quickFilter.dateFilter);
  }

  //  For data quick filters, structure is:
  //    dataQuickFilter: { dataFilter: { initialValue: {...values}, mappedInitialValue: {...values} } }
  if (quickFilter.valueSource === ValueSource.Mapped) {
    return Boolean(quickFilter.dataFilter?.mappedInitialValue);
  }

  return !isEmpty(quickFilter.dataFilter?.initialValue);
}
